require.context("../images", true, /^.*\.(?!gz$)[^.]+$/);
require.context("../videos", true, /^.*\.(?!gz$)[^.]+$/);

import jquery from "jquery";
window.jQuery = window.$ = jquery;
import _ from "underscore";
window._ = _;

import tinymceConfig from "assets/javascripts/config/tinymce_config";
import cplook from "cplook";
import "spectrum-colorpicker";
import IframeResizer from "iframe-resizer";
import "ekko-lightbox";
import elm from "assets/elm/elm.js";

window.tinymce_config = tinymceConfig;
window.iFrameResize = IframeResizer.iframeResizer;

// stimulus
import "@stimulus/polyfills";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
const application = Application.start();
const context = require.context(
  "../../../assets/javascripts/controllers",
  true,
  /\.js$/
);
application.load(definitionsFromContext(context));

require("assets/javascripts/base/shared");
import PdfForm from "../../../node_modules/pdf_form/assets/javascripts/pdf_form/global/elm/form.coffee";
PdfForm(elm);

require("assets/javascripts/external/jquery_cycle2");

require("assets/javascripts/base/_stale");

require("assets/javascripts/base/admin");
require("assets/javascripts/base/global")(elm);
require("assets/javascripts/base/manage");
require("assets/javascripts/base/super");

require("assets/javascripts/embed/embed");

$(document).ready(function () {
  cplook.editor.init_tinymce();
});
